import FullPageLoader from 'components/common/FullPageLoader';
import { interpreterName } from 'helpers/interpreterName';
import { usePermissions } from 'layouts/Admin';
import moment from 'moment';
import React from 'react'
import { Link } from 'react-router-dom';

const PdfForm = ({ data, invoiceNumber, loader, type }) => {
    const { checkPermission } = usePermissions();
    const clientData = data?.client || data;
    const totalBill = clientData?.appointments?.reduce((sum, item) => sum + (item?.invoice?.total_amount || 0), 0).toFixed(2);
    return (
        <>
            <div className="page">
                <header>
                    <div className="us">
                        <img src="/main-logo.png" alt="Logo" />
                    </div>

                    <div className='d-flex align-items-center'>
                        <div className="title">
                            <h4>INVOICE # {data?.invoice_number || invoiceNumber || 'N/A'}</h4>
                        </div>
                        <div className="title">
                            <h4>Date: {data?.billing_date
                                ? new Date(data.billing_date).toLocaleDateString('en-GB')
                                : new Date().toLocaleDateString('en-GB')}</h4>
                        </div>
                    </div>
                </header>

                <section>
                    <div className="billed-to">
                        <h1>Bill To</h1>
                        <h2>{clientData?.user?.name}</h2>
                        <h3>{clientData?.user?.email}</h3>
                        <h3>{clientData?.phone}</h3>
                    </div>

                    <div className="invoice-table-wrapper">
                        <table className="invoice-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Description</th>
                                    <th>Cost</th>
                                </tr>
                            </thead>
                            <tbody>
                                {clientData?.appointments.map((val, index) => {
                                    const totalHours = val?.invoice?.total_hours;
                                    const totalMinutes = val?.invoice?.total_hours ? (parseInt(totalHours.split(":")[0]) * 60) + parseInt(totalHours.split(":")[1]) : 0;
                                    const minDuration = val?.invoice?.min_duration;
                                    const minDurUnit = val?.invoice?.duration_unit;
                                    const minDurationHours = minDurUnit === 'hour' ? minDuration * 60 : minDuration;
                                    const isValid = totalMinutes >= minDurationHours;
                                    const inc = val?.invoice?.incremental;
                                    const incremental = inc == '30_minute' ? '30 minute' : inc == '1_hour' ? 'hourly' : inc == 'minute' ? 'per minute' : null;
                                    const rushFee = val?.invoice?.rush_fee;
                                    return (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>
                                                {checkPermission('Detail Appointments') ?
                                                    <span>Appointment Number: {val?.appid ? <Link to={`/appointments/view/${val?.id}`}>{val?.appid}</Link> : 'N/A'}</span>
                                                    :
                                                    <span>Appointment Number: {val?.appid || 'N/A'}</span>

                                                }
                                                {type !== 'compressed' &&
                                                    <>
                                                        <br /><span>Language: {val?.language?.name || 'N/A'}</span><br />
                                                        <span>Status: {val?.status || 'N/A'}</span><br />
                                                        <span>Appointment type: {val?.type || 'N/A'}</span><br />
                                                        <span>Appointment date: {moment(val.date).format("DD/MM/YYYY") || 'N/A'}</span><br />
                                                        <span>
                                                            Appointment start: {val?.appointment_assign?.checkin_time
                                                                ? `${moment(val.appointment_assign.checkin_date).format("DD/MM/YYYY")} ${moment(val.appointment_assign.checkin_time, "HH:mm:ss").format("h:mm A")}`
                                                                : 'N/A'}
                                                        </span><br />
                                                        <span>
                                                            Appointment end: {val?.appointment_assign?.checkout_time
                                                                ? `${moment(val.appointment_assign.checkout_date).format("DD/MM/YYYY")} ${moment(val.appointment_assign.checkout_time, "HH:mm:ss").format("h:mm A")}`
                                                                : 'N/A'}
                                                        </span><br />
                                                        <span className='vertical_center'>
                                                            Appointment duration: {val?.invoice?.total_hours
                                                                ? moment.utc(moment.duration(val.invoice.total_hours, "HH:mm").asMilliseconds()).format("HH:mm")
                                                                : 'N/A'}&nbsp;

                                                            {(isValid === false || incremental != null) && (
                                                                <span className="font-bold text-red-600">
                                                                    {`(`}
                                                                    {isValid === false ? `min duration: ${minDuration} ${minDurUnit}` : ""}
                                                                    {isValid === false && incremental != null ? `, ` : ""}
                                                                    {incremental != null ? `Incremental: ${incremental}` : ""}
                                                                    {`)`}
                                                                </span>
                                                            )}
                                                        </span><br />
                                                        <span>Estimated duration: {val?.duration || 0} min</span><br />
                                                        <span>Rate: ${val?.invoice?.rate || 0}{val?.invoice?.rate_unit ? `/${val.invoice.rate_unit}` : ''}</span><br />
                                                        { rushFee > 0 && <><span className='vertical_center'>Rush fee: ${rushFee} <span className="font-bold text-red-600">{`(The appointment is scheduled within 24 hours.)`}</span></span><br /></>}
                                                        
                                                        <span>Facility: {val?.appointment_details?.facility?.abbreviation || 'N/A'}</span><br />
                                                        <span>Facility Address {val?.appointment_details?.facility?.address || 'N/A'}</span><br />
                                                        <span>Department: {val?.appointment_details?.department?.department_name || 'N/A'}</span><br />
                                                        <span>Requestor Name: {val?.appointment_details?.requester_name || 'N/A'}</span><br />
                                                        <span>Requestor Email: {val?.appointment_details?.requester_email || 'N/A'}</span><br />
                                                        <span>Requestor Phone: {val?.appointment_details?.requester_phone || 'N/A'}</span><br />
                                                        <span>Interpreter Name: {interpreterName(val?.interpreter) || 'N/A'}</span><br />
                                                        <span>comments: {val?.appointment_assign?.comments || 'N/A'}</span><br />
                                                        <span>Notes: {val?.appointment_assign?.notes || 'N/A'}</span>
                                                    </>
                                                }
                                            </td>
                                            <td>${val?.invoice?.total_amount ? val.invoice.total_amount.toFixed(2) : 0}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>

                    <table className="info-container last_info">
                        <tr>
                            <th className='text-end last_due'>Total Due</th>
                            <th className='text-end last_due'>
                                ${
                                    totalBill
                                }
                            </th>
                        </tr>
                    </table>

                </section>
            </div>
            {loader &&
                <FullPageLoader />
            }
        </>
    )
}

export default PdfForm